import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("NEW+ ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Create A New Green Grant.", -1)
const _hoisted_4 = { style: {"margin-left":"10px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"width":"120px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Grant Id ")
const _hoisted_8 = { style: {"width":"300px"} }
const _hoisted_9 = { style: {"width":"120px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Dao Id ")
const _hoisted_11 = { style: {"width":"300px"} }
const _hoisted_12 = { style: {"width":"120px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Dao Name ")
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = { style: {"width":"120px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Title ")
const _hoisted_17 = { style: {"width":"300px"} }
const _hoisted_18 = { style: {"width":"120px"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Description ")
const _hoisted_20 = { style: {"width":"300px"} }
const _hoisted_21 = { style: {"width":"120px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("End Time ")
const _hoisted_23 = { style: {"width":"300px"} }
const _hoisted_24 = { style: {"width":"120px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Pay Token ")
const _hoisted_26 = { style: {"width":"300px"} }
const _hoisted_27 = { style: {"width":"120px"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Github ")
const _hoisted_29 = { style: {"width":"300px"} }
const _hoisted_30 = { style: {"width":"120px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Website ")
const _hoisted_32 = { style: {"width":"300px"} }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, null, -1)
const _hoisted_34 = { style: {"width":"300px"} }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Select Folder")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("cancel")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_39 = { class: "card-header" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Id: ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Support")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Claim")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Github")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Next ")

import { getCurrentInstance, ComponentInternalInstance, h, ref } from 'vue'

import { toRaw } from '@vue/reactivity'
import * as path from "path"
import type { UploadInstance, UploadFile, UploadFiles } from 'element-plus'

import { connected, connectState } from "../libs/connect"
import * as constant from "../constant"
import * as element from "../libs/element"
import * as tools from "../libs/tools"
import * as storage from '../libs/storage'

import { ERC20 } from "../libs/erc20"
import { GreenDao } from "../libs/greendao"
import { GreenGrant } from "../libs/greengrant"


const __default__ = {
  name: 'GrantsPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const uploadWebsite = ref<UploadInstance>();

const greendao = new GreenDao();
const greengrant = new GreenGrant();

const zeroAddress = '0x0000000000000000000000000000000000000000';
const timeFormat = "YYYY/MM/DD hh:mm:ss";

const activeName = connectState.activeName;

const loadStatus = ref(false);
const loadDrawerStatus = ref(false);
const loadWebsiteStatus = ref(false);

const daoId = ref(0);
const daoName = ref('');
const grantId = ref(0);
const grantTitle = ref('');
const grantDescription = ref('');
const grantGitUrl = ref('');
const grantWebsite = ref('');
const grantToken = ref('');
const grantEndTime = ref('');

const showAddNewGrantVisiable = ref(false);
const websiteFileList = ref(new Array());

const greenGrantList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(6);
const pageCount = ref(0);

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//get block chain native currency
const getTokenCurencyName = async (token:string) => {
  if(token === zeroAddress){
    for(const i in constant.chainList){
      if(constant.chainList[i].chainId === connectState.chainId){
        return constant.chainList[i].nativeCurrency;
      }
    }
  }else{
    const erc20 = new ERC20(token);
    return await erc20.symbol();
  }
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//get dao id
const getDaoId = () => {
  const daoId = tools.getUrlParamter('daoId');
  try{
    return Number(daoId);
  }catch(e){
    return 0;
  }
}

//update dao name by dao id
const updateDaoName = async (daoId:Number) => {
  const daoInfo = await greendao.getDaoInfoById(daoId);
  daoName.value = daoInfo.daoName;
}

//on website folder change
const onChangeSelectWebsiteFolder = async (uploadFile: UploadFile, uploadFiles: UploadFiles) => {
  websiteFileList.value = toRaw(uploadFiles);
  
  grantWebsite.value = (websiteFileList.value[0].raw as any).webkitRelativePath.split(path.sep)[0];
  if(grantWebsite.value === ''){
    grantWebsite.value = (websiteFileList.value[0].raw as any).name;
  }
}

//on click to select website folder
const onSelectWebsiteFolder = async () => {
  uploadWebsite.value!.clearFiles();
}

//on click to upload website folder
const onUploadWebsiteFolder = async () => {
    try{

      loadWebsiteStatus.value = true;

      if(toRaw(websiteFileList.value).length === 0){
        element.elMessage('warning', 'You have not select any folder to upload!');
        return;
      }

      let directory = (websiteFileList.value[0].raw as any).webkitRelativePath.split(path.sep)[0];
      if(directory === ''){
        directory = (websiteFileList.value[0].raw as any).name;
      }

      let findIndex = false;

      for(const i in websiteFileList.value){
        const file = websiteFileList.value[i];
        if((file.raw as any).name === 'index.html'){
          findIndex = true;
          break;
        }
      }

      if(findIndex === false){
        element.elMessage('warning', 'Not a valid website folder, index.html not found in the root path!');
        return;
      }

      grantWebsite.value = await storage.uploadFolder(directory, toRaw(websiteFileList.value));
    }catch(e){
      element.alertMessage(e);
    }finally{
      loadWebsiteStatus.value = false;
    }
}      

//click to open the drawer to create a new grant
const onAddNewGrantOpen = async () => {
  const currentClass = (proxy as any).$el.parentNode.querySelector(".upload-website");

  (currentClass.querySelector(".el-upload__input") as any).webkitdirectory = true;  

  await updateDaoName(daoId.value);
}

//click to edit the green grant
const onEditGreenGrant = async(grantInfo:any) => {
  daoId.value = grantInfo.daoId;
  grantId.value = grantInfo.grantId;
  grantTitle.value = grantInfo.grantName;
  grantDescription.value = grantInfo.grantDesc;
  grantGitUrl.value = grantInfo.grantGitUrl;
  grantWebsite.value = grantInfo.grantWebsite;
  grantToken.value = grantInfo.grantToken;
  grantEndTime.value = (new Date(grantInfo.endTime*1000)).toLocaleString();

  showAddNewGrantVisiable.value = true;
}

//click to add a new green grant
const onAddGreenGrant = async () => {
  daoId.value = getDaoId();
  grantId.value = 0;
  grantTitle.value = '';
  grantDescription.value = '';
  grantGitUrl.value = '';
  grantWebsite.value = '';
  grantToken.value = zeroAddress;

  const now = new Date();
  now.setTime(now.getTime() + 30*24*3600*1000);
  grantEndTime.value = now.toLocaleString();

  showAddNewGrantVisiable.value = true;
}

//click to cancel grant update
const cancelGrantUpdate = async () => {
  showAddNewGrantVisiable.value = false;
}

//click to confirm to update or create the grant
const confirmGrantUpdate = async () => {

  try{
    loadDrawerStatus.value = true;

    const endTime = new Date(grantEndTime.value).getTime()/1000;

    if(grantId.value > 0){
      const tx = await greengrant.updateGrant(grantId.value, grantTitle.value, grantDescription.value, grantGitUrl.value, grantWebsite.value, endTime);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Update grant success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);        
    }else{
      const tx = await greengrant.mint(grantTitle.value, grantDescription.value, grantGitUrl.value, grantWebsite.value, grantToken.value, daoId.value, endTime);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Create grant success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);      
    }    

    showAddNewGrantVisiable.value = false;

    handleClick();     

  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }  
}

//click to delete a green grant
const onDeleteGreenGrant = async (grantId:number) => {
  try{
    const tx = await greengrant.burn(grantId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Delete grant success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }
}

//click to support the grant
const onSupportGrant = async (grantInfo:any) => {
  const opts = {
    message: '',
    confirmButtonText: 'Send',
    cancelButtonText: 'Cancel',
    inputType: 'number',
    inputValue: '1',
    inputPlaceholder: '0',
    inputErrorMessage: 'Invalid value',
  };

  const erc20 = new ERC20(grantInfo.grantToken);

  const tokenSymbol = await getTokenCurencyName(grantInfo.grantToken);
  const tokenBalance = await erc20.balanceOf(connectState.userAddr.value);

  if(grantInfo.grantToken === zeroAddress){
    opts.message =  h('p', null, [
      h('p', null, 'Please enter the token amount to support the grant:'),
      h('p', { style: 'color: teal' }, `dao id: ${grantInfo.daoId}`),
      h('p', { style: 'color: teal' }, `dao name: ${grantInfo.daoName}`),
      h('p', { style: 'color: teal' }, `grant id: ${grantInfo.grantId}`),
      h('p', { style: 'color: teal' }, `grant name: ${grantInfo.grantName}`),
      h('p', { style: 'color: teal' }, `token name: ${tokenSymbol}`),
      h('p', { style: 'color: teal' }, `token balance: ${tokenBalance}`),
    ]);
  }else{
    opts.message =  h('p', null, [
      h('p', null, 'Please enter the token amount to support the grant:'),
      h('p', { style: 'color: teal' }, `dao id: ${grantInfo.daoId}`),
      h('p', { style: 'color: teal' }, `dao name: ${grantInfo.daoName}`),
      h('p', { style: 'color: teal' }, `grant id: ${grantInfo.grantId}`),
      h('p', { style: 'color: teal' }, `grant name: ${grantInfo.grantName}`),
      h('p', { style: 'color: teal' }, `token name: ${tokenSymbol}`),
      h('p', { style: 'color: teal' }, `token contract: ${grantInfo.grantToken}`),
      h('p', { style: 'color: teal' }, `token balance: ${tokenBalance}`),
    ]);
  }

  element.elMessageBox('Please enter the token amount to support the grant:', 'Send Token', opts, async (value:number) => {
    if(value <= 0){
      element.alertMessage("support token value must large than zero!");
      return;
    }

    try{
      if(grantInfo.grantToken != zeroAddress){
        const tx = await erc20.approve(greengrant.getAddress(), value);
        connectState.transactions.value.unshift(tx);
        connectState.transactionCount.value++;
        const msg = `<div><span>Approve token success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      }

      const tx = await greengrant.supportGrant(grantInfo.grantId, value);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Support the grant success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;

      handleClick();
    }catch(e){
      element.alertMessage(e);
    }

  });  
}

//click to claim the grant treassure
const onClaimGrant = async (grantId: number) => {
  try{
    const tx = await greengrant.claimGrant(grantId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Claim grant success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }
}

//get green grant infos by page size and page count
const getGreenGrantCount = async (onlyOwner:boolean) => {
  daoId.value = getDaoId();

  const indexs = await greengrant.getGrantIndexsByPageCount(pageSize.value, pageCount.value, daoId.value, onlyOwner);

  if(indexs.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  const infoList = new Array();
  for(const i in indexs){
    const res = await greengrant.getGrantInfoById(indexs[i]);

    res.grantEnded = res.endTime < (new Date().getTime()/1000);
    res.grantOwner = await greengrant.ownerOf(indexs[i]);
    res.grantTreassure = (await greengrant.getGrantTreassure(indexs[i], false)).toPrecision(4);
    res.isOwner = res.grantOwner.toLowerCase() === connectState.userAddr.value.toLowerCase();

    //if dao not exists, skip
    try{
      const daoInfo = await greendao.getDaoInfoById(res.daoId);
      res.daoName = daoInfo.daoName;
      res.daoAvatar = daoInfo.daoAvatar;
      res.daoWebsite = daoInfo.daoWebsite;
      res.daoDesc = daoInfo.daoDesc;
      res.daoOwner = daoInfo.daoOwner;
      res.daoPublic = daoInfo.daoPublic;
      res.daoMembers = daoInfo.daoMembers;
    }catch(e){
      continue;
    }

    infoList.push(res);
  }

  greenGrantList.value = infoList;
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//handle page refresh
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);
    
  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);
  try{
    loadStatus.value = true;
    if (!(await connected())){
      greenGrantList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    const onlyOwner = activeName.value === 'mine';

    await getGreenGrantCount(onlyOwner);

  }catch(e){
    greenGrantList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'all' && 
    activeName.value != 'mine'){
    activeName.value = 'all';
  }
}catch(e){
  activeName.value = 'all';
}
//update page size
handleClick();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "All",
                  name: "all"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Mine",
                  name: "mine"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              style: {"float":"right","margin-right":"50px"},
              onClick: onAddGreenGrant
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_drawer, {
              modelValue: showAddNewGrantVisiable.value,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showAddNewGrantVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onAddNewGrantOpen
            }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_4, [
                  (grantId.value > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            title: "Grant Id",
                            width: 200,
                            trigger: "hover",
                            content: "The id of the green grant."
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createVNode(_component_el_input, {
                            modelValue: grantId.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((grantId).value = $event)),
                            disabled: ""
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_icon, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickToCopy(grantId.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Id",
                        width: 200,
                        trigger: "hover",
                        content: "The dao id of the green dao. The grant must be published through the dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_el_input, {
                        modelValue: daoId.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((daoId).value = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (updateDaoName(daoId.value))),
                        disabled: grantId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickToCopy(daoId.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Name",
                        width: 200,
                        trigger: "hover",
                        content: "The name of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_el_input, {
                        modelValue: daoName.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((daoName).value = $event)),
                        disabled: ""
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (onClickToCopy(daoName.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Grant Title",
                        width: 200,
                        trigger: "hover",
                        content: "The title of the green grant."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_el_input, {
                        modelValue: grantTitle.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((grantTitle).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (onClickToCopy(grantTitle.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Grant Description",
                        width: 200,
                        trigger: "hover",
                        content: "The description of the green grant."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createVNode(_component_el_input, {
                        modelValue: grantDescription.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((grantDescription).value = $event)),
                        type: "textarea",
                        rows: "5"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Grant End Time",
                        width: 200,
                        trigger: "hover",
                        content: "The end time of the green grant."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: grantEndTime.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((grantEndTime).value = $event)),
                        style: {"width":"100%"},
                        type: "datetime",
                        placeholder: "Pick a Date",
                        format: timeFormat
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Grant Pay Token",
                        width: 200,
                        trigger: "hover",
                        content: "The payment token contract to support for the green grant. You can choose the blockchain native token or the erc20 tokens to receive the payments."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createVNode(_component_el_input, {
                        modelValue: grantToken.value,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((grantToken).value = $event)),
                        disabled: grantId.value > 0
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (onClickToCopy(grantToken.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Grant Github",
                        width: 200,
                        trigger: "hover",
                        content: "The github url link of the green grant."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      _createVNode(_component_el_input, {
                        modelValue: grantGitUrl.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((grantGitUrl).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (onClickToCopy(grantGitUrl.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Grant Website",
                        width: 200,
                        trigger: "hover",
                        content: "The website link of the green grant. You can input the url link directly or upload the website folder through the upload button."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createVNode(_component_el_input, {
                        modelValue: grantWebsite.value,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((grantWebsite).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (onClickToCopy(grantWebsite.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("tr", {
                    "element-loading-text": "Uploading...",
                    "element-loading-spinner": svg,
                    "element-loading-svg-view-box": "-10, -10, 50, 50",
                    "element-loading-background": "#ffffff"
                  }, [
                    _hoisted_33,
                    _createElementVNode("td", _hoisted_34, [
                      _createVNode(_component_el_upload, {
                        style: {"width":"100px","height":"0px","float":"right","margin-right":"100px"},
                        drag: false,
                        multiple: true,
                        class: "upload-website",
                        ref_key: "uploadWebsite",
                        ref: uploadWebsite,
                        action: "",
                        onChange: onChangeSelectWebsiteFolder,
                        onClick: onSelectWebsiteFolder,
                        limit: 0,
                        "show-file-list": false,
                        "auto-upload": false
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            style: {"float":"right","margin-right":"10px","width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_35
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_el_button, {
                        type: "success",
                        style: {"float":"right"},
                        onClick: onUploadWebsiteFolder
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      })
                    ])
                  ])), [
                    [_directive_loading, loadWebsiteStatus.value]
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Submitting...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_button, { onClick: cancelGrantUpdate }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmGrantUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(greenGrantList.value, (info) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: info.grantId,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "box-card" }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Dao Info"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: info.daoWebsite
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_avatar, {
                                      src: info.daoAvatar,
                                      size: "small"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Name: " + _toDisplayString(info.daoName), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_40,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greendao).getAddress(),info.daoId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, [
                                  _hoisted_41,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.daoOwner)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.daoOwner), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Members: " + _toDisplayString(info.daoMembers), 1),
                                _createElementVNode("h4", null, "Public: " + _toDisplayString(info.daoPublic), 1),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.daoDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_popover, {
                              placement: "bottom-start",
                              width: 230,
                              title: "Grant Info"
                            }, {
                              reference: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(greengrant).getAddress(),info.grantId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.grantName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h4", null, "Title: " + _toDisplayString(info.grantName), 1),
                                _createElementVNode("h4", null, [
                                  _hoisted_42,
                                  _createVNode(_component_el_link, {
                                    type: "success",
                                    target: "_blank",
                                    href: addressExplorerUrl(info.grantOwner)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.grantOwner), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _createElementVNode("h4", null, "Description: " + _toDisplayString(info.grantDesc), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", null, [
                              (_unref(activeName) === 'mine')
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "danger",
                                    style: {"float":"right"},
                                    size: "small",
                                    onClick: ($event: any) => (onDeleteGreenGrant(info.grantId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_unref(activeName) === 'mine')
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    style: {"float":"right"},
                                    size: "small",
                                    onClick: ($event: any) => (onEditGreenGrant(info))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Edit)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("iframe", {
                                frameborder: "0",
                                sandbox: "allow-scripts allow-same-origin allow-popups",
                                src: info.grantWebsite,
                                style: {"width":"250px","height":"200px"}
                              }, null, 8, _hoisted_43)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, "Endtime: " + _toDisplayString((new Date(info.endTime*1000)).toLocaleString()), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                type: "primary",
                                style: {"float":"right"},
                                href: "javascript:void(0);"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Received : " + _toDisplayString(info.grantTreassure), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (info.grantEnded === false && info.grantPayed === false)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onSupportGrant(info))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_44
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (info.isOwner === true && info.grantEnded === true && info.grantPayed === false)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 1,
                                    type: "primary",
                                    style: {"float":"right"},
                                    onClick: ($event: any) => (onClaimGrant(info.grantId))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_45
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_link, {
                                type: "primary",
                                style: {"float":"right"},
                                href: info.grantGitUrl,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_46
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _hoisted_48
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})